<template>
  <div class="story-list">
    <AddContentButton color="#1877F2" @click="onClickAddStory">Add Story</AddContentButton>
    <div class="row">
      <perfect-scrollbar class="col-md-8">
        <ContentsList
          ref="contentsList"
          @edit="onEditContent"
          :types="['story']"
          :emptyText="emptyText"
        />
      </perfect-scrollbar>
      <perfect-scrollbar class="col-md-4 filter ps-filter">
        <FilterList @onAdd="onClickAdd" />
      </perfect-scrollbar>
    </div>
    <transition name="fade">
      <ExperienceForm v-if="showExperienceForm" @close="onClose" :content="content" />
      <EventForm v-if="showEventForm" @close="onClose" :content="content" />
      <TourForm v-if="showTourForm" @close="onClose" :content="content" />
      <StoriesForm v-if="showForm" @close="onClose" :content="content" />
    </transition>
  </div>
</template>

<script>
import AddContentButton from "@/components/AddContentButton";
import ContentsList from "@/components/ContentsList";
import ExperienceForm from "@/components/ExperienceForm";
import EventForm from "@/components/EventForm";
import StoriesForm from "@/components/Contents/Stories/StoriesForm";
import TourForm from "@/components/TourForm";
import FilterList from "@/components/Lists/Filter";
export default {
  name: "StoryLists",
  components: {
    AddContentButton,
    ContentsList,
    ExperienceForm,
    EventForm,
    StoriesForm,
    TourForm,
    FilterList,
  },
  data() {
    return {
      showExperienceForm: false,
      showEventForm: false,
      showTourForm: false,
      showForm: false,
      content: null,
      emptyText:
        "This account has no offer yet. Please press the ADD button above",
    };
  },
  methods: {
    onClickAdd(type) {
      if (type == "experience") {
        this.showExperienceForm = true;
      }

      if (type == "event") {
        this.showEventForm = true;
      }

      if (type == "tour") {
        this.showTourForm = true;
      }

      if (type == "story") {
        this.showForm = true;
      }
    },
    onClickAddStory() {
      this.showForm = true;
    },
    onClose() {
      this.showExperienceForm = false;
      this.showEventForm = false;
      this.showTourForm = false;
      this.showForm = false;
      this.reload();
    },
    reload() {
      this.content = null;
      this.$refs.contentsList.reload();
    },
    async onEditContent(id, type) {
      this.content = await this.$repo.story.getStory(id);
      this.showForm = true;
    },
  },
};
</script>

<style lang="scss">
.story-list {
  padding-top: 50px;

  .ps {
    height: 77vh;
  }

  .ps-filter {
    height: 77vh;
    overflow: hidden;
  }
}
</style>